import { Box } from "@mui/system";
import React from "react";
import WorksTablePlanning from "../components/WorkTable";

const Planning = () => {
	return (
		<Box
			maxWidth={"100%"}
			flexGrow={1}
			display={"flex"}
			flexDirection={"column"}
			alignItems={"flex-start"}
			sx={{ gap: "2rem" }}
		>
			<WorksTablePlanning />
		</Box>
	);
};

export default Planning;
